import { useNavigate } from "react-router";
import { Button, Result } from "antd";

/**
 * 404 Not Found Page
 * Displayed when user navigates to non-existent route
 */
export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center p-8">
      <Result
        status="404"
        title="404"
        subTitle="抱歉，您訪問的頁面不存在。"
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            返回首頁
          </Button>
        }
      />
    </div>
  );
}
